<script setup lang="ts">
  import type { MenuItem } from '@/routes'
  import LzpLogo from '@/lzp-logo.vue'
  import { MenuBar } from '@logistiek-zonder-papier/lzp-library'

  defineProps<{
    firstName: string
    lastName: string
    organizationName: string
    toggled: boolean
    menu: MenuItem[]
  }>()
</script>

<template>
  <nav id="sidebar" class="sidebar" :class="{ toggled }">
    <a class="sidebar-brand" href="#" onclick="headHome();">
      <LzpLogo class="logo-lzp" />
    </a>
    <div class="sidebar-content">
      <div class="sidebar-user">
        <div id="sidebar-content">
          <div class="fw-bold">{{ firstName }} {{ lastName }}</div>
        </div>
        <div id="sidebar-org-info">
          <div>{{ organizationName }}</div>
        </div>
      </div>
      <MenuBar :menu-config="menu" />
    </div>
  </nav>
</template>

<style lang="css" scoped>
  .sidebar {
    display: flex;
    height: 100vh;
    flex-direction: column;
    background: #1f88e5;
    border-right: 0;
    box-shadow: 0 0 2rem 0 rgba(0, 0, 0, 0.05);
    max-width: 250px;
    min-width: 250px;
    transition:
      margin-left 0.3s ease-in-out,
      left 0.3s ease-in-out,
      margin-right 0.3s ease-in-out,
      right 0.3s ease-in-out;
    z-index: 1;
  }

  .sidebar-user {
    background: #fff;
    color: var(--colours-grey-5);
    padding: 1.5rem 1rem 1rem;
    text-align: center;
  }

  .sidebar-content {
    padding: 0 var(--spacing-s);
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    transition:
      margin-left 0.3s ease-in-out,
      left 0.3s ease-in-out,
      margin-right 0.3s ease-in-out,
      right 0.3s ease-in-out;
  }

  .sidebar-content,
  .sidebar-nav {
    background: #fff;
    display: flex;
    flex-direction: column;
  }

  .sidebar.toggled {
    margin-left: -250px;
  }

  .sidebar.toggled .sidebar-content {
    left: -250px;
  }

  @media (min-width: 1px) and (max-width: 991.98px) {
    .sidebar {
      margin-left: -250px;
    }

    .sidebar .sidebar-content {
      left: -250px;
    }

    .sidebar.toggled {
      margin-left: 0;
    }

    .sidebar.toggled .sidebar-content {
      left: 0;
    }
  }
</style>
